// extracted by mini-css-extract-plugin
module.exports = {"mobile-width":"StatusToastNotification_mobile-width__25L9o","mobileWidth":"StatusToastNotification_mobile-width__25L9o"};